import React from 'react';
import { IQuestion } from '../types/get-started.type';
import ProgressBar from 'components/ProgressBar';
import Button from 'components/Form/Button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Icon, Icons } from 'components/Icon';
import Question from './Question';
import { quetions } from 'constants/survey';

type Props = {
  onSubmit: (formValue: IQuestion) => void;
};

export default function QuestionOne({ onSubmit }: Props) {
  const formik = useFormik({
    initialValues: {
      doYouHaveWill: '',
      doYouHaveSpouse: '',
      doYouHaveUnderAgeChild: '',
      doYouHaveInsurance: '',
      doYouHavePensionAccount: ''
    },
    validationSchema: Yup.object({
      doYouHaveWill: Yup.string().required(
        'Have you written a will before is required'
      ),
      doYouHaveSpouse: Yup.string().required(
        'Do you have a spouse or partner is required'
      ),
      doYouHaveUnderAgeChild: Yup.string().required(
        'Do you have a child under 18 is required'
      ),
      doYouHaveInsurance: Yup.string().required(
        'Do you have insurance is required'
      ),
      doYouHavePensionAccount: Yup.string().required(
        'Do you have a pension account is required'
      )
    }),
    onSubmit: (values, { setFieldTouched }) => {
      for (const key in values) {
        setFieldTouched(key, true);
      }
      onSubmit(values);
    }
  });

  const handleChange = (fieldName: string, fieldValue: boolean | string) => {
    formik.setFieldValue(fieldName, fieldValue);
  };

  return (
    <div className="mx-20 my-16 flex flex-col items-center ">
      <p className="w-[60%] text-center text-4xl font-medium text-[#353535]">
        Just some questions to help us advise the kind of will that makes sense
        for you.
      </p>
      <div className="my-10 w-[50%]">
        <ProgressBar percentage={20} />
      </div>
      <form
        autoComplete="false"
        className="flex flex-col items-center text-center"
        onSubmit={formik.handleSubmit}
      >
        {quetions.map(question => {
          const error = (formik.errors as { [key: string]: string })[
            question.fieldName
          ];
          const value = (formik.values as { [key: string]: string })[
            question.fieldName
          ];
          return (
            <Question
              key={question.id}
              question={question.question}
              fieldName={question.fieldName}
              error={error}
              handleChange={handleChange}
              fieldValue={value}
            />
          );
        })}
        <Button
          variant="primary"
          size="md"
          iconPosition="right"
          icon={<Icon name={Icons.ArrowRight} />}
          className="mt-12 w-[15rem] rounded border-[#353535] p-[0.1rem]"
          label="PROCEED"
          type="submit"
        ></Button>
      </form>
    </div>
  );
}
